var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsInt, IsOptional, IsString, Min } from 'class-validator';
export class UpdateOfficeProductAssignmentLineItemDto {
    currentCount;
    maxCount;
    title;
}
__decorate([
    IsInt(),
    Min(0),
    Expose(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateOfficeProductAssignmentLineItemDto.prototype, "currentCount", void 0);
__decorate([
    IsInt(),
    Min(1),
    Expose(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateOfficeProductAssignmentLineItemDto.prototype, "maxCount", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateOfficeProductAssignmentLineItemDto.prototype, "title", void 0);
//# sourceMappingURL=update-office-product-assignment-line-item.dto.js.map